module.exports = __webpack_public_path__ + "static/media/bg_funnil.c7972f2f.svg";